export default "__VITE_ASSET__BtN8sLG7__"